import React from 'react';
import {getCurrentUser} from "../services/authService";
import Translate from "./Translate";
import '../css/Pagination.css'

const currentUser = getCurrentUser() ? getCurrentUser() : {language: 'en'};


const Pagination = ({ currentPage, totalPages, handlePreviousPage, handleNextPage, handlePageClick, rowsPerPage, handleRowsPerPageChange, pageNumbers, totalResources }) => {
    return (
        <div className="pagination-container">
            <div className="rows-per-page">
                <label htmlFor="rowsPerPage">
                    <Translate language={currentUser.language} text={'rowsPerPage'}/>
                </label>
                <select id="rowsPerPage" value={rowsPerPage} onChange={handleRowsPerPageChange}>
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                    <option value="500">500</option>
                </select>
            </div>

            <div><Translate language={currentUser.language} text={'count'}/>: {totalResources}</div>

            <div className="pagination">
                <button onClick={handlePreviousPage} disabled={currentPage === 1}>
                    &#8592;
                </button>
                {pageNumbers.map((pageNumber, index) => (
                    <button
                        key={index}
                        onClick={() => handlePageClick(pageNumber)}
                        className={pageNumber === currentPage ? 'active' : ''}
                        disabled={pageNumber === '...'}
                    >
                        {pageNumber}
                    </button>
                ))}
                <button onClick={handleNextPage} disabled={currentPage === totalPages}>
                    &#8594;
                </button>
            </div>
        </div>
    );
};

export default Pagination;
